import React from 'react';
import { useSelector } from 'react-redux';
import LineGraphMain from './graphInMainPopup/lineGraph/LineGraphMain';
import CircleGraphMain from './graphInMainPopup/circleGraph/CircleGraphMain';
import { useGraphSystemLogData } from 'utils/customHook/useGraphSystemLogData';

const MainLogPopup = ({ title, engTitle, logIdx, moduleIdx, moduleScn }) => {
  const criterion = useSelector(store => store.criterion);
  const logData = useGraphSystemLogData(title, logIdx);
  const lineData = logData === null ? [] : [...logData].reverse();
  
  if (!logData) {
    return null;
  }
  
  return (
    <div>
      <LineGraphMain data={lineData} moduleIdx={moduleIdx} moduleScn={moduleScn} engTitle={engTitle} title={title} criterion={criterion[engTitle]} />
      <CircleGraphMain criterion={criterion[engTitle]} {...logData[0]} />
    </div>
  )
}

export default React.memo(MainLogPopup);